import { ReactElement } from "react";
import { isNotNil } from "client/Misc/utils";
import { ExpandableText } from "client/Components";
import { Section, SectionEmptyBehavior } from "./Section";

export type MultilineTextSectionProps = {
	label: string;
	trackingId: string;
	text: string | null;
	emptyBehavior: SectionEmptyBehavior;
};

export const MultilineTextSection = (props: MultilineTextSectionProps): ReactElement => {
	const {
		label,
		trackingId,
		text,
		emptyBehavior
	} = props;

	return (
		<Section
			title={label}
			trackingId={trackingId}
			emptyBehavior={emptyBehavior}
			isEmpty={!text}
		>
			{isNotNil(text) && (
				<ExpandableText
					text={text}
					preserveBreaks
					maxLines={10}
				/>
			)}
		</Section>
	);
};
MultilineTextSection.displayName = "MultilineTextSection";